/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var isFunction = require('../core/isFunction')
var _once = require('../core/once')

// once : ((*) -> b) -> ((*) -> b)
function once(fn) {
  if(!isFunction(fn)) {
    throw new TypeError('once: Function required')
  }

  return _once(fn)
}

module.exports = once
